import { useTranslation } from 'i18n';
import { Chip } from 'ui';

export const AIChip = () => {
  const { t } = useTranslation('features');

  return <Chip size="small" color="primary" label={t('evidence.chips.ai')} />;
};
